import { ToggleButton } from "primereact/togglebutton";

const EditorSectionHeader = ({
  className,
  title,
  isBerangkat,
  showBerangkat,
  setShowBerangkat,
}) => {
  return (
    <div className={className}>
      <span className="text-sm font-bold text-slate-700">{title}</span>
      {!isBerangkat && (
        <ToggleButton
          onLabel="Pergi"
          offLabel="Pergi"
          checked={showBerangkat}
          onChange={(e) => setShowBerangkat((prev) => !prev)}
          onIcon="pi pi-eye"
          offIcon="pi pi-eye-slash"
        />
      )}
    </div>
  );
};

export default EditorSectionHeader;
